/**
 * OSS文件管理 API 服务
 * 提供OSS文件管理相关的 API 调用
 */
import api, { API_BASE_URL } from './api'

// ============================================================
// 类型定义
// ============================================================

export interface OssFileData {
    id: number
    file_name?: string
    file_size?: number
    file_ext?: string
    file_path?: string
    md5?: string
    is_public: boolean
    is_deleted: boolean
    deleted_at?: string
    created_at: string,
    preview_url?: string
}

export interface OssFileListQuery {
    page?: number
    page_size?: number,
    is_public?: boolean
}

export interface PaginatedResponse<T> {
    total: number
    page: number
    page_size: number
    items: T[]
}

// ============================================================
// API 方法
// ============================================================

export const ossApi = {

    uploadPublicUrl: API_BASE_URL + '/oss/upload/public',
    uploadPrivateUrl: API_BASE_URL + '/oss/upload/private',

    /**
     * 获取OSS文件详情
     * GET /oss/{file_id}
     */
    getOssFileById: (fileId: number) => {
        return api.get<OssFileData>(`/oss/${fileId}`)
    },

    /**
     * 删除OSS文件
     * DELETE /oss/{file_id}
     */
    deleteOssFile: (fileId: number) => {
        return api.delete(`/oss/${fileId}`)
    },

    /**
     * 获取OSS文件列表
     * GET /oss/list
     */
    getOssFileList: (params: OssFileListQuery = {}) => {
        return api.get<PaginatedResponse<OssFileData>>('/oss/list', { params })
    }
}